import React, { PureComponent } from "react";
import {getTrans} from '../../common/index'
import {
  TransContext,
  TeamDataContext,
  ConstraintsContext,
} from "../../Context";
import OutsideNotifier from "./../OutsideNotifier";
import { Consume } from "../../Context/Consumer";
import config from "../../common/config";

class PopupError extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: true,
    };
  }

  componentDidMount() {
    console.log(this.props.errorObj);

    setTimeout(() => {
      this.onClose();
    }, 5000);
  }

  onClose = () => {
    this.props.TeamData.setErroObj({});
    this.setState({
      closeModal: false,
    });
  };

  render() {
    let self = this;
    let { state, props } = self;
    let { closeModal } = state;
    let { errorObj,TransData } = props;
    let { playersPerSkillCountExceeded, playersPerTeamCountExceeded } =
      errorObj;
    let toastMsg = null;
    if (playersPerSkillCountExceeded) {
      toastMsg = getTrans(TransData.data,'Players_Error_Skill') /* `you have exceeded the max number of players for ${
        config.positionMap[this.props.errorObj.skill].key
      }` */;
    } else if (playersPerTeamCountExceeded) {
      toastMsg = getTrans(TransData.data,'Players_Error_Team')/* "you have exceeded the max number of players for teams" */;
    }

    return closeModal ? (
      <div className="si-popup__wrap si-toast__popup si-fade in">
        <OutsideNotifier handler={this.onClose}>
          <div className="si-popup__container">
            <div className="si-popup__body">
              <div
                className="si-popup__close"
                onClick={this.onClose}
                style={{ userSelect: "auto" }}
              >
                <div
                  className="si-btn__adRe"
                  style={{ userSelect: "auto" }}
                ></div>
              </div>
              <div className="si-toast__box si-danger">
                <div className="si-toast__icon"></div>
                <div className="si-toast__text">
                  <span>{toastMsg}</span>
                </div>
              </div>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    ) : null;
  }
}

export default Consume(PopupError, [
  TransContext,
  TeamDataContext,
  ConstraintsContext,
]);
